import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Icon } from '@iconify/react/dist/iconify.js';
import useReactApexChart from '../../../../hook/useReactApexChart';

const FREQUENCY_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'yearly', label: 'Yearly' },
];

const ROW_PALETTE = [
    { icon: 'mdi:account-group', text: 'text-orange', bar: 'bg-orange' },
    { icon: 'mdi:account-multiple', text: 'text-success-main', bar: 'bg-success-main' },
    { icon: 'mdi:briefcase-account', text: 'text-info-main', bar: 'bg-info-main' },
    { icon: 'mdi:account-key', text: 'text-primary-600', bar: 'bg-primary-600' },
];

const CampaignStaticOne = ({ userTypes, frequency = 'monthly', onFrequencyChange = () => { } }) => {
    const { donutChartSeriesTwo, donutChartOptionsTwo } = useReactApexChart();
    const items = userTypes?.items || [];

    return (
        <div className="col-xxl-4">
            <div className="row gy-4">
                <div className="col-xxl-12 col-sm-6">
                    <div className="card h-100 radius-8 border-0">
                        <div className="card-body p-24">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 fw-bold text-lg">User Types</h6>
                                <div>
                                    <select
                                        className="form-select form-select-sm w-auto bg-base border text-secondary-light"
                                        value={frequency}
                                        onChange={(e) => onFrequencyChange(e.target.value)}
                                    >
                                        {FREQUENCY_OPTIONS.map((o) => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="mt-3">
                                {items.length === 0 ? (
                                    <p className="text-sm text-secondary-light mb-0">No data yet</p>
                                ) : items.map((row, idx) => {
                                    const style = ROW_PALETTE[idx % ROW_PALETTE.length];
                                    const pct = Number(row.percentage) || 0;
                                    return (
                                        <div key={row.type || idx} className="d-flex align-items-center justify-content-between gap-3 mb-12">
                                            <div className="d-flex align-items-center">
                                                <span className={`text-xxl line-height-1 d-flex align-content-center flex-shrink-0 ${style.text}`}>
                                                    <Icon icon={style.icon} className="icon" />
                                                </span>
                                                <span className="text-primary-light fw-medium text-sm ps-12">
                                                    {row.type}
                                                </span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 w-100">
                                                <div className="w-100 max-w-66 ms-auto">
                                                    <div
                                                        className="progress progress-sm rounded-pill"
                                                        role="progressbar"
                                                        aria-valuenow={pct}
                                                        aria-valuemin={0}
                                                        aria-valuemax={100}
                                                    >
                                                        <div
                                                            className={`progress-bar ${style.bar} rounded-pill`}
                                                            style={{ width: `${pct}%` }}
                                                        />
                                                    </div>
                                                </div>
                                                <span className="text-secondary-light font-xs fw-semibold">
                                                    {pct}%
                                                </span>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xxl-12 col-sm-6">
                    <div className="card h-100 radius-8 border-0 overflow-hidden">
                        <div className="card-body p-24">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 fw-bold text-lg">Top Brands</h6>
                                <div>
                                    <select className="form-select form-select-sm w-auto bg-base border text-secondary-light" defaultValue="Select Frequency">
                                        <option value="Select Frequency" disabled>Select Frequency</option>
                                        <option value="Yearly">Yearly</option>
                                        <option value="Monthly">Monthly</option>
                                        <option value="Weekly">Weekly</option>
                                        <option value="Today">Today</option>
                                    </select>
                                </div>
                            </div>
                            <div className="d-flex flex-wrap align-items-center mt-3">
                                <ul className="flex-shrink-0">
                                    <li className="d-flex align-items-center gap-2 mb-28">
                                        <span className="w-12-px h-12-px rounded-circle bg-success-main" />
                                        <span className="text-secondary-light text-sm fw-medium">Brand 1</span>
                                    </li>
                                    <li className="d-flex align-items-center gap-2 mb-28">
                                        <span className="w-12-px h-12-px rounded-circle bg-warning-main" />
                                        <span className="text-secondary-light text-sm fw-medium">Brand 2</span>
                                    </li>
                                    <li className="d-flex align-items-center gap-2">
                                        <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                                        <span className="text-secondary-light text-sm fw-medium">Brand 3</span>
                                    </li>
                                </ul>
                                <div>
                                    <ReactApexChart
                                        options={donutChartOptionsTwo}
                                        series={donutChartSeriesTwo}
                                        type="donut"
                                        height={300}
                                        id="donutChart"
                                        className="flex-grow-1 apexcharts-tooltip-z-none title-style circle-none"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignStaticOne;
